// Generated by Melange

import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Stdlib__Float from "melange/float.js";

const Invalid = /* @__PURE__ */ Caml_exceptions.create("Mapre_wire.Json.Invalid");

const obj = Js__Js_dict.fromList;

function str(prim) {
  return prim;
}

function num(n) {
  return n;
}

function bool(prim) {
  return prim;
}

function get(json, key) {
  const object_ = Js__Js_json.decodeObject(json);
  if (object_ !== undefined) {
    const value = Js__Js_dict.get(Caml_option.valFromOption(object_), key);
    if (value !== undefined) {
      return Caml_option.valFromOption(value);
    }
    throw new Caml_js_exceptions.MelangeError(Invalid, {
        MEL_EXN_ID: Invalid,
        _1: "missing_" + key
      });
  }
  throw new Caml_js_exceptions.MelangeError(Invalid, {
      MEL_EXN_ID: Invalid,
      _1: "expected_object"
    });
}

function string(json, key) {
  const s = Js__Js_json.decodeString(get(json, key));
  if (s !== undefined) {
    if (s !== "") {
      return s;
    }
    throw new Caml_js_exceptions.MelangeError(Invalid, {
        MEL_EXN_ID: Invalid,
        _1: "invalid_" + key
      });
  }
  throw new Caml_js_exceptions.MelangeError(Invalid, {
      MEL_EXN_ID: Invalid,
      _1: "invalid_" + key
    });
}

function text(json, key) {
  const s = Js__Js_json.decodeString(get(json, key));
  if (s !== undefined) {
    return s;
  }
  throw new Caml_js_exceptions.MelangeError(Invalid, {
      MEL_EXN_ID: Invalid,
      _1: "invalid_" + key
    });
}

function integer(json, key) {
  const f = Js__Js_json.decodeNumber(get(json, key));
  if (f !== undefined) {
    if (Stdlib__Float.is_finite(f) && f === Math.floor(f) && f >= -2147483648 && f <= 2147483647) {
      return f | 0;
    }
    throw new Caml_js_exceptions.MelangeError(Invalid, {
        MEL_EXN_ID: Invalid,
        _1: "invalid_" + key
      });
  }
  throw new Caml_js_exceptions.MelangeError(Invalid, {
      MEL_EXN_ID: Invalid,
      _1: "invalid_" + key
    });
}

function array(json, key) {
  const a = Js__Js_json.decodeArray(get(json, key));
  if (a !== undefined) {
    return a;
  }
  throw new Caml_js_exceptions.MelangeError(Invalid, {
      MEL_EXN_ID: Invalid,
      _1: "invalid_" + key
    });
}

function error(code) {
  return Js__Js_dict.fromList({
    hd: [
      "error",
      code
    ],
    tl: /* [] */ 0
  });
}

export {
  Invalid,
  obj,
  str,
  num,
  bool,
  get,
  string,
  text,
  integer,
  array,
  error,
}
/* Stdlib__Float Not a pure module */
